module.exports = __webpack_public_path__ + "static/media/roboto-mono-v5-latin-300italic.c24ee49d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/roboto-mono/roboto-mono-v5-latin-300italic.ttf
// module id = 487
// module chunks = 0